// extracted by mini-css-extract-plugin
export default {"customInputNumber":"customInputNumber_customInputNumber__lbNLI","borderedNone":"customInputNumber_borderedNone__jk45s","suffix":"customInputNumber_suffix__p6CKt"};